// Team スライダー
const swiper1 = new Swiper(".swiper1", {
  loop: true,
  speed: 1000, // 少しゆっくり(デフォルトは300)
  autoplay: { // 自動再生
    delay: 2000, // 1.5秒後に次のスライド
  },
  slidesPerView: 1,
  centeredSlides: true,
  effect: 'fade',
  fadeEffect: {
      crossFade: true,
  },
  scrollbar: {
    el: '.swiper-scrollbar',
    draggable: true,
    // dragClass: '.swiper-scrollbar-drag',
    // dragSize: '50',
  },
});

//Gallery スライダー
// サムネイル
const sliderThumbnail = new Swiper(".slider-thumbnail", {
  autoplay: true,
  slidesPerView: 'auto',
  spaceBetween: 10,
  grabCursor: true,
  breakpoints: {
    768: {
      spaceBetween: 20,
    }
  },
  scrollbar: {
      el: '.slider-thumbnail .swiper-scrollbar',
      draggable: true,
  },
});
// メインスライダー
const swiper2 = new Swiper(".main_swiper", {
  loop: true,
  autoplay: true,
  slidesPerView: 1,
  effect: 'fade',
  fadeEffect: {
      crossFade: true,
  },
  thumbs: {
    swiper: sliderThumbnail,
  },
});

AOS.init();

